<template>
    <ins class="adsbygoogle"
         data-google-adtest="on"
         :data-ad-client="adClient"
         :data-ad-slot="adSlot"
         :data-ad-format="adFormat"
         :style="adStyle"></ins>

</template>

<script>
    export default {
        props: {
            adClient: {
                type: String,
                required: true
            },
            adSlot: {
                type: String,
                required: true
            },
            adFormat: {
                type: String,
                required: false,
                default: 'auto'
            },
            adStyle: {
                type: String,
                required: false,
                default: 'display: block'
            }
        },
        mounted() {
            (window.adsbygoogle = window.adsbygoogle || []).push({})
        }
    }
</script>




// WEBPACK FOOTER //
// AdSense.vue?10b7931e